import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button, Alert, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Cookies from 'js-cookie';
import { API_BASE_URL } from "../config";

function Login() {
  const [celular, setCelular] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loginData, setLoginData] = useState(null); // agora armazena ambos os perfis

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro("");

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, {
        celular,
        senha,
      });

      const { master, funcionario } = response.data;

      // Se nenhum retornou
      if (!master && !funcionario) {
        setErro("Celular ou senha inválidos.");
        return;
      }

      // Se existe master e também funcionario → abre modal
      if (master && funcionario) {
        setLoginData({ master, funcionario });
        setShowModal(true);
        return;
      }

      // Se só tem master
      if (master) {
        fazerLoginComo("admin", master);
        return;
      }

      // Se só tem funcionario
      if (funcionario) {
        fazerLoginComo("func", funcionario);
        return;
      }

    } catch (err) {
      console.error(err);
      setErro("Celular ou senha inválidos.");
    }
  };

  const fazerLoginComo = (tipo, data) => {
    Cookies.set("authToken", data.token, { expires: 7 });
    Cookies.set("usuario", JSON.stringify({
      id: data.id,
      nome: data.nome,
      role: tipo === "admin" ? "ClienteMaster" : "Funcionario",
      celular: data.celular,
      slug: data.slug
    }), { expires: 7 });

    if (tipo === "admin") {
      navigate("/sistema-master");
    } else {
      navigate("/sistema");
    }
  };

  return (
    <>
<div 
  style={{ 
    background: 'linear-gradient(to right, #898989, #192435ff)', 
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '20px',
    paddingRight: '20px'
  }}
>

  <Card className="shadow-lg" style={{ width: '100%', maxWidth: '380px', borderRadius: '15px' }}>
    <Card.Body className="p-4">
      <h3 className="text-center mb-4" style={{ color: '#898989' }}>Login</h3>
      {erro && <Alert variant="danger">{erro}</Alert>}

      <Form onSubmit={handleLogin}>
        <Form.Group className="mb-3">
          <Form.Label>Celular</Form.Label>
          <Form.Control
            type="text"
            placeholder="Digite seu celular"
            value={celular}
            onChange={(e) => setCelular(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Senha</Form.Label>
          <Form.Control
            type="password"
            placeholder="Digite sua senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            required
          />
        </Form.Group>

        <Button 
          variant="primary" 
          type="submit" 
          className="w-100"
          style={{ 
            background: 'linear-gradient(to right, #898989, #192435ff)', 
            border: 'none' 
          }}
        >
          Entrar
        </Button>

        <div className="text-center mt-3">
          <a href="/forgot-password">Esqueci minha senha</a>
        </div>
      </Form>
    </Card.Body>
  </Card>
</div>


      {/* Modal de escolha de perfil */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Escolha como deseja logar</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Seu número está registrado como <b>Administrador</b> e <b>Funcionário</b>.</p>
          <p>Como deseja entrar?</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => { setShowModal(false); fazerLoginComo("func", loginData.funcionario); }}>
            Entrar como Funcionário
          </Button>

          <Button variant="primary" onClick={() => { setShowModal(false); fazerLoginComo("admin", loginData.master); }}>
            Entrar como Administrador
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Login;
